import {Locations} from "./Locations";
import {Routes} from "react-router";
import {Route, useLocation} from "react-router-dom";
import React from "react";
import {AddOrEditLocation} from "./AddOrEditLocation";
import {BusinessProfile} from "./BusinessProfile";
import {useProviderProfile} from "../../../../ProviderProfileProvider";

export const useProfileTabs = () => {

  const location = useLocation();
  const {business} = useProviderProfile();

  const generalTab = {
    label: 'General',
    link: '/home/profile',
    isSelected: location.pathname == '/home/profile',
  };

  const locationsTabs = {
    label: 'Locations',
    link: '/home/profile/locations',
    isSelected: location.pathname.startsWith('/home/profile/locations'),
  };

  if (business?.businessSettings?.offersInPersonServices) {
    return [generalTab, locationsTabs]
  } else {
    return [generalTab];
  }
}

export const ProfileRouter = () => {
  return <Routes>
    <Route path="/locations" element={<Locations/>}/>
    <Route path='/locations/add' element={<AddOrEditLocation/>}/>
    <Route path='/locations/edit/:idParam' element={<AddOrEditLocation/>}/>

    {/* Catchall */}
    <Route path="/" element={<BusinessProfile/>}/>

  </Routes>
}